<!-- <IFA-header></IFA-header> -->
<main role="main" class="customMain">
  <div class="Optimum-official-offerings" id="Optimum-wealth-home">
    <div
      class="home-wealth-faq wealth-section-space wealth-faq-wrapper"
      id="Myth">
      <div class="container mt-5">
        <div class="col-12 mbnopadding">
          <h2 class="wealth-section-title mobilsectionmyth">
            Myths & Facts about Mutual Funds
          </h2>

          <!-- new accordian-->
          <div class="accordion_container">
            <div class="col-sm-12 col-md-12 col-xs-12 nopadding">
              <div class="row">
                <div class="col-md-6 col-xs-6 col-sm-6 mbnopadding nopadding">
                  <div class="col-md-12 col-xs-12 col-sm-12">
                    <div class="accordion_head">
                      Myth : Mutual Fund investments are only for the long term
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="item-text">
                        <p>
                          <strong>Fact :</strong>
                          Mutual funds can be for the short term or for longer
                          term based on one’s investment horizon and objective.
                        </p>

                        <p>
                          There are different types of mutual fund schemes –
                          which invest in different types of securities – in
                          equity as well as debt securities that are suitable
                          for different investor needs.
                        </p>

                        <p>
                          In fact, there are various short-term schemes where
                          you can invest for a few days to a few weeks to a few
                          years e.g., Liquid Funds are low duration funds, with
                          portfolio maturity of less than 91 days, while Ultra
                          short-Term Bond Funds are low duration funds, with
                          portfolio maturity of less than a year. There are
                          Short-Term Bond Funds which are medium duration funds
                          where the underlying portfolio maturity ranges from
                          one year – three years. Then, there are Long-Term
                          Income Funds which are medium to long duration funds
                          with portfolio maturity between 3 and 10 years.
                        </p>

                        <p>
                          While Equity Schemes are most suitable for a longer
                          term, debt mutual funds are suitable for investors
                          with short term (less than 5 years) investment
                          horizon.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 col-xs-12 col-sm-12">
                    <div class="accordion_head">
                      Myth : A Scheme with a higher NAV has reached its peak !
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="wealth-faq-collapse-content" itemprop="text">
                        <div class="item-text">
                          <p>
                            <strong>Fact :</strong>
                            This is a very common misconception because of the
                            general association of Mutual Funds with shares. One
                            needs to keep in mind that the NAV of a scheme is
                            nothing but a reflection of the market value of the
                            underlying shares held by the fund on any day.
                            Mutual Funds invest in shares, which may be bought
                            or sold whenever deemed appropriate by the Fund
                            Manager depending on the scheme’s investment
                            strategy (Buy-Hold-Sell). If the Fund Manager feels
                            that a particular stock has peaked, he can choose to
                            sell it.
                          </p>

                          <p>
                            A high NAV does not mean the fund is expensive. In
                            fact, high NAV indicates a good performance of the
                            scheme over the years.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-xs-12 col-sm-12">
                    <div class="accordion_head">
                      Myth : Mutual Funds are for experts
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="wealth-faq-collapse-content" itemprop="text">
                        <div class="item-text">
                          <p>
                            <strong>Fact :</strong>
                            In fact, Mutual funds are meant for of common
                            investors who may lack the knowledge or skill set to
                            invest in securities market. Mutual Funds are
                            professionally managed by expert Fund Managers after
                            extensive market research for the benefit of
                            investors. A mutual fund is an inexpensive way for
                            investors to get a full-time professional fund
                            manager to manage their money.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-xs-12 col-sm-12">
                    <div class="accordion_head">
                      Myth : Investing in mutual funds is the same as investing
                      <br />
                      in stock market
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="wealth-faq-collapse-content" itemprop="text">
                        <p>
                          <strong>Fact :</strong>
                          Mutual Funds invest in stock market (i.e., equities),
                          bond market (corporate bonds as well as govt. bonds)
                          and Money Market instruments such as Treasury Bills,
                          Commercial Papers, Certificate of Deposit, Collateral
                          Borrowing &amp; Lending Obligation (CBLO) etc. Many of
                          these instruments are not available to retail
                          investors due to large ticket size of minimum order
                          quantity (such as G-Secs) and hence, retail investors
                          could participate in such investments through mutual
                          fund schemes
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-xs-6 col-sm-6 mbnopadding nopadding">
                  <div class="col-md-12 col-xs-12 col-sm-6">
                    <div class="accordion_head">
                      Myth : Buying a top-rated mutual fund scheme ensures
                      better returns.
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="wealth-faq-collapse-content" itemprop="text">
                        <div class="item-text">
                          <p>
                            <strong>Fact :</strong>
                            Mutual fund ratings are dynamic and based on
                            performance of the scheme over time – which in
                            itself is subject to market fluctuations. So, a
                            Mutual fund scheme that may be on top of the rating
                            chart currently, may not necessarily maintain the
                            same rating month after month or at a later date .
                            However, a top rated fund is a good first step to
                            short list a scheme to invest in (although past
                            performance does not necessarily guarantee better
                            returns in future). Investment in a mutual fund
                            scheme needs to be tracked with respect to the
                            scheme’s benchmark to evaluate its performance
                            periodically to decide whether to stay invested or
                            to exit.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-xs-12 col-sm-6">
                    <div class="accordion_head">
                      Myth : One needs to have a Demat account to invest in
                      Mutual Funds
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="wealth-faq-collapse-content" itemprop="text">
                        <div class="item-text">
                          <p>
                            <strong>Fact :</strong>
                            Holding mutual fund Units in Demat mode is
                            absolutely optional, except in respect of Exchange
                            Traded Funds. For all other schemes, including the
                            close-ended listed schemes like Fixed Maturity Plans
                            (FMPs), it is entirely upto the investor whether to
                            hold the units in a Demat mode or in conventional
                            physical accountant statement mode.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-xs-12 col-sm-6">
                    <div class="accordion_head">
                      Myth : One needs a large amount of money to invest in
                      Mutual Funds
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="item-text">
                        <p>
                          <strong>Fact :</strong>
                          Absolutely incorrect. One could start investing mutual
                          funds with just ₹5000 for a lump-sum / one-time
                          investment with no upper limit and ₹1000 towards
                          subsequent / additional subscription in most of the
                          mutual fund schemes. And for Equity linked Savings
                          Schemes (ELSS), the minimum amount is as low as ₹ 500.
                        </p>

                        <p>
                          In fact, one could invest via Systematic Investment
                          Plan ( SIP) with as little as ₹500 per month for as
                          long as one wishes to.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12 col-xs-12 col-sm-6">
                    <div class="accordion_head">
                      Myth : Mutual Fund scheme with a NAV is ₹10 per Unit
                      better than Mutual Fund scheme whose NAV is ₹25 per unit
                      <span class="plusminus">+</span>
                    </div>
                    <div class="accordion_body" style="display: none">
                      <div class="item-text">
                        <p>
                          <strong>Fact :</strong>
                          This is a common misconception. A mutual fund's NAV
                          represents the market value of all its underlying
                          investments.
                          <span class="red-txt">
                            NAV of a fund is irrelevant, because it represents
                            the market value of the fund’s investments and not
                            the market price.
                          </span>
                          Any capital appreciation will depend on the price
                          movement of its underlying securities. Let us
                          understand this through an illustration.
                        </p>

                        <p>
                          Suppose, you invest ₹10,000 each in scheme A whose NAV
                          is ₹20 and scheme B (whose NAV is say, ₹100. You will
                          be allotted 500 units of scheme A and 100 units of
                          scheme B. Assuming that both schemes have invested
                          their entire corpus in exactly same stocks and in the
                          same proportions, if the underlying stocks
                          collectively appreciate by 10%, the NAV of the two
                          schemes should also rise by 10%, to ₹22 and ₹110,
                          respectively. Thus, in both the scenarios, the value
                          of your investment increases to ₹ 11,000.
                        </p>

                        <p>
                          Thus, the current NAV of a fund does not have any
                          impact on the returns.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="home-wealth-faq wealth-section-space wealth-faq-wrapper"
      id="FAQ">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="content-panelMobile">
              <h2 class="wealth-section-title">Frequently Asked Questions</h2>
              <div class="accordion_container">
                <div class="col-sm-12 col-md-12 col-xs-12 nopadding">
                  <div class="row">
                    <div
                      class="col-md-6 col-xs-6 col-sm-6 mbnopadding nopadding">
                      <div class="col-md-12 col-xs-12 col-sm-12">
                        <div class="accordion_head">
                          What is NAV ?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div class="item-text">
                            <p>
                              The performance of a particular scheme of a mutual
                              fund is denoted by Net Asset Value (NAV). In
                              simple words, NAV is the market value of the
                              securities held by the scheme.
                            </p>
                            <p>
                              Mutual funds invest the money collected from
                              investors in securities markets. Since market
                              value of securities changes every day, NAV of a
                              scheme also varies on day to day basis.
                            </p>
                            <p>
                              The NAV per unit is the market value of securities
                              of a scheme divided by the total number of units
                              of the scheme on any particular date.
                            </p>
                            <p>
                              For example, if the market value of securities of
                              a mutual fund scheme is INR 200 lakh and the
                              mutual fund has issued 10 lakh units of INR 10
                              each to the investors, then the NAV per unit of
                              the fund is INR 20 (i.e.200 lakh/10 lakh). NAV is
                              required to be disclosed by the mutual funds on a
                              daily basis. The NAV per unit of all mutual fund
                              schemes have to be updated on AMFIís website and
                              the Mutual Funds’ website by 9 p.m. of the same
                              day. Fund of Funds are allowed time till 10 a.m.
                              the following business day to update the
                              information.
                            </p>
                            <p>
                              Unlike stocks (where the price is driven by the
                              market and changes from minute-to-minute) , mutual
                              funds don't declare NAVs through the day.
                            </p>
                            <p>
                              Instead, NAVs of all mutual fund schemes are
                              declared at the end of the trading day after
                              markets are closed, in accordance with SEBI Mutual
                              Fund Regulations.&nbsp; Further, as per SEBI
                              Mutual Fund Regulations, for all mutual fund
                              schemes, other than liquid fund schemes, the
                              mutual fund Units are allotted only at prospective
                              NAV, i.e., the NAV that would be declared at the
                              end of the day, based on the closing market value
                              of the securities held in the respective schemes.
                            </p>
                            <p>
                              Thus, what is important here is the cut-off time
                              for submission/receipt of the transaction – If you
                              invest before the cut-off time, you will get the
                              end-of-day NAV of that particular business day.
                              The cut off time for purchase transactions for all
                              mutual fund schemes other than liquid fund schemes
                              is 3:00 p.m. This means that if you have invested
                              till 3:00 p.m. on a particular day, you will get
                              that day's NAV.
                            </p>
                            <p>
                              A mutual fund may accept applications even after
                              the cut-off&nbsp;time,&nbsp; but you will get the
                              NAV of the next business day. Further, the cut-off
                              time rules apply for redemptions too.&nbsp;
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-12">
                        <div class="accordion_head">
                          How is the applicable NAV determined?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div
                            class="wealth-faq-collapse-content"
                            itemprop="text">
                            <div>
                              <p>Liquid Funds</p>
                              <p>- Subscription</p>
                              <p></p>
                              <ul>
                                <li>
                                  Where the application is received up to 2.00
                                  p.m. on a day and funds are available for
                                  utilization before 2:00 p.m. without availing
                                  any credit facility, the closing NAV of the
                                  day immediately preceding the day of receipt
                                  of application.
                                </li>
                                <li>
                                  Where the application is received after 2.00
                                  p.m. on a day and funds are available for
                                  utilization on the same day without availing
                                  any credit facility, the closing NAV of the
                                  day immediately preceding the next business
                                  day; and
                                </li>
                                <li>
                                  Irrespective of the time of receipt of
                                  application (before or after 2:00 p.m. on a
                                  day), where the funds are not available for
                                  utilization before 2:00 p.m. without availing
                                  any credit facility, the closing NAV of the
                                  day immediately preceding the day on which the
                                  funds are available for utilization.
                                </li>
                              </ul>
                              <p>- Redemption</p>
                              <ul>
                                <li>
                                  Where the application is received up to 3.00
                                  pm – the closing NAV of day immediately
                                  preceding the next business day; and
                                </li>
                                <li>
                                  Where the application is received after 3.00
                                  pm – the closing NAV of the next business day.
                                </li>
                              </ul>
                              <strong>
                                Other Schemes [other than Liquid Funds]
                              </strong>
                              <p>a. Subscription</p>

                              <p>For amount less than ₹2 lakh</p>

                              <ul>
                                <li>
                                  Where the application is received up to 3:00
                                  p.m., closing NAV of the day on which the
                                  application is received.
                                </li>
                                <li>
                                  2. Where the application is received after
                                  3:00 p.m., closing NAV of the next business
                                  day.
                                </li>
                              </ul>
                              <p>For amount equal to ₹2 lakh or more</p>
                              <ul>
                                <li>
                                  Where the application is received up to 3:00
                                  p.m. and funds are available for utilization
                                  before 3:00 p.m., closing NAV of the day on
                                  which the application is received.
                                </li>
                                <li>
                                  Where the application is received after 3:00
                                  p.m. and funds are available for utilization,
                                  closing NAV of the next business day.
                                </li>
                                <li>
                                  Irrespective of the time of receipt of
                                  application (before or after 3:00 p.m.), where
                                  the funds are not available for utilization,
                                  closing NAV of the day on which the funds are
                                  available for utilization.
                                </li>
                              </ul>
                              <p>b. Redemption</p>
                              <ul>
                                <li>
                                  Where the application is received up to 3.00
                                  pm – closing NAV of the day on which the
                                  application is received; and
                                </li>
                                <li>
                                  Where the application is received after 3.00
                                  pm – closing NAV of the next business day.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-12">
                        <div class="accordion_head">
                          Where can one get information on NAVs of mutual funds?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div
                            class="wealth-faq-collapse-content"
                            itemprop="text">
                            <div class="item-text">
                              <p>
                                All mutual funds publish their scheme NAVs on
                                their respective web sites.
                              </p>
                              <p>
                                In addition, one can also access the NAVs of all
                                mutual funds on the web site of Association of
                                Mutual Funds in India (AMFI)
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-12">
                        <div class="accordion_head">
                          What are cut-off times?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div
                            class="wealth-faq-collapse-content"
                            itemprop="text">
                            <div class="item-text">
                              <p>
                                The Cut-off timing is the time before which an
                                investor has to submit a valid purchase or
                                withdrawal/ redemption form to be eligible for a
                                particular day's price or Net Asset Value (NAV).
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-12">
                        <div class="accordion_head">
                          What is sale and repurchase/redemption price?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div
                            class="wealth-faq-collapse-content"
                            itemprop="text">
                            <div class="item-text">
                              <p>
                                The price or NAV a unit holder is charged while
                                investing in a mutual fund scheme is called
                                sales price.
                              </p>
                              <p>
                                Repurchase or redemption price is the price or
                                NAV at which a mutual fund repurchases (buys
                                back) / redeems its units from the unitholders.
                                It may include exit load, if applicable.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-6 col-xs-6 col-sm-6 mbnopadding nopadding">
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="accordion_head">
                          What is the purpose for cut-off times for purchases &
                          redemption?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div
                            class="wealth-faq-collapse-content"
                            itemprop="text">
                            <div class="item-text">
                              <p>
                                Mutual funds are market linked investments. They
                                invest in either Equity, Bond or Gold markets
                                and these markets have fixed open and closing
                                hours for trading. The NAV of a scheme is based
                                market value of the underlying portfolio and
                                thus highly correlated with the market prices.
                                So in order to be eligible for a particular
                                days' NAV, the fund manager needs to be aware of
                                the amount that needs to be purchased or sold as
                                per the settlement period and trading times of
                                the markets. The timings also largely help in
                                ensuring that all classes of investors get the
                                same treatment irrespective of their quantum of
                                investing.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="accordion_head">
                          What is a Folio number?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div
                            class="wealth-faq-collapse-content"
                            itemprop="text">
                            <div class="item-text">
                              <p>
                                Much like a bank account number, a Folio number
                                is your Account Number in a Mutual Fund Scheme,
                                under which yours Unit holdings in a mutual fund
                                scheme are recorded in the Unit Holders’
                                Register.
                              </p>

                              <p>
                                Most Mutual Funds allot a Master Folio number,
                                so that Unit holdings of a unit holder (or same
                                set of unit holders, in case of joint holders)
                                are shown under a common folio number thereby
                                avoiding the need to remember multiple folio
                                numbers.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="accordion_head">
                          What is an Account Statement?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div class="item-text">
                            <p>
                              As the name suggests, it is a statement that
                              reflects your holding in a scheme. A statement of
                              accounts is like a bank pass book.
                            </p>
                            <p>
                              An account statement will reflect the following
                            </p>

                            <ul>
                              <li>The scheme in which you have invested.</li>
                              <li>
                                The amount you've invested, the purchase price
                                and the units you were allotted.
                              </li>
                              <li>
                                Other details like Bank details, mailing and
                                contact details, nominee details etc.
                              </li>
                            </ul>
                            <p>
                              The Mutual Funds issue a Consolidated Account
                              Statement (CAS) across all fund houses once a
                              month. However, one may request for an account
                              statement with each fund house that will solely
                              reflect the holdings in the schemes managed by
                              that particular fund house. There may be charges
                              levied for issue of a duplicate account statement.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-6">
                        <div class="accordion_head">
                          When does the investor get an account statement after
                          investing.
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div class="item-text">
                            <p>
                              Mutual funds are required to issue statements of
                              accounts within five working days from the date of
                              closure of the initial subscription of the scheme.
                              In case of close-ended schemes, the investors
                              would get either a demat account statement as
                              these are traded in the stock exchanges. In case
                              of open-ended schemes, a statement of account is
                              issued by the mutual fund within five working days
                              from the date of closure of initial public offer
                              of the scheme and/or from the date of receipt of
                              the request from the unitholders. The procedure of
                              repurchase is mentioned in the offer document.
                            </p>

                            <p>
                              Also, AMCs are required to send confirmation
                              specifying the number of units allotted to the
                              applicant by way of email and/or SMS’s to the
                              applicant’s registered email address and/or mobile
                              number as soon as possible but not later than five
                              working days from the date of closure of the
                              initial subscription list and/or from the date of
                              receipt of the request from the unitholders.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-xs-12 col-sm-12">
                        <div class="accordion_head">
                          Can Non-Resident Indians (NRIs) invest in mutual
                          funds?
                          <span class="plusminus">+</span>
                        </div>
                        <div class="accordion_body" style="display: none">
                          <div
                            class="wealth-faq-collapse-content"
                            itemprop="text">
                            <div class="item-text">
                              <p>
                                Yes, non-resident Indians can invest in mutual
                                funds in India. Please refer to the respective
                                mutual fund’s offer documents for details.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="grid-layout-common">
      <div class="container">
        <div class="col-md-12 col-xs-12 col-sm-12 nopadding">
          <div class="product-card-grid hover-animation" data-grid-size="8">
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card"
              href="mf/Mutual-Fund"
              target="_self">
              <span>
                Mutual Funds -
                <br />
                <span class="no-wrap-text">Introduction & More</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card"
              href="mf/Types_Of_MF"
              target="_self">
              <span>
                Various types
                <br />
                <span class="no-wrap-text">of Mutual Funds</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card"
              href="mf/SIP"
              target="_self">
              <span>
                Systematic
                <br />
                <span class="no-wrap-text">Investment Plan?</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card"
              href="mf/Advantages_Of_MutualFundsComponent"
              target="_self">
              <span>
                Advantages of
                <br />
                <span class="no-wrap-text">Mutual Funds</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card"
              href="mf/categorization-of-mutual-funds"
              target="_self">
              <span>
                Categorisation of
                <br />
                <span class="no-wrap-text">Mutual Funds</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card"
              href="mf/risks-in-mutual-funds"
              target="_self">
              <span>
                Risk Factors in
                <br />
                <span class="no-wrap-text">Mutual Funds</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card active"
              href="mf/FAQ#Myth"
              target="_self">
              <span>
                Myths & Facts
                <br />
                <span class="no-wrap-text">about Mutual Funds</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-45ec3075-02fd-412a-b8a5-9aeea39facf3"
              class="card"
              href="mf/FAQ#FAQ"
              target="_self">
              <span>
                What is NAV?
                <br />
                <span class="no-wrap-text">& Other FAQs</span>
              </span>
              <span class="icon fa fa-angle-right"></span>
            </a>
            <a
              id="id-ebe318f3-49dd-4b4f-9c3a-0cb8514a69fd"
              class="card link-plain featured customCard"
              (click)="modalPopOpen()"
              target="_self">
              <p
                style="
                  font-size: 19px;
                  color: #000;
                  font-weight: bold;
                  margin-bottom: 0px;
                ">
                Schedule a Call back
              </p>
            </a>
          </div>
        </div>
      </div>
    </section>
    <!-- lets talk of model -->

    <div
      aria-hidden="true"
      aria-labelledby="LetsTalk_popup"
      class="modal fade"
      data-keyboard="false"
      id="LetsTalk_popup"
      tabindex="-1">
      <div class="modal-dialog modal-dialog-centered border-0">
        <div class="modal-content border-0 p-0">
          <div class="modal-header border-0 p-0 ltmodalheader">
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body border-0 p-10 pt-0 mobilep-2">
            <form>
              <div
                class="col-sm-12 col-md-12 col-xs-12 schedule-a-call-container">
                <div class="align-self-center">
                  <h2
                    class="wealth-section-title mb-8 mobilemb-5 mobilemt-0 fcwelth">
                    Let's Talk
                  </h2>

                  <p
                    class="wealth-section-description mb-12 mt-10 mobilemt-0 mobilemb-10">
                    Let's connect on a quick call to understand better.
                  </p>
                </div>

                <div class="row">
                  <div class="col-sm-12 col-md-12 col-xs-12 mt-10 mobilemt-0">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        id="customer_name"
                        maxlength="30"
                        placeholder="Full Name"
                        name="customer-name"
                        required=""
                        type="text" />
                      <label for="customer-name"></label>
                      <span
                        class="d-none customer-name-error"
                        style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div>
                  <!-- <div class="col-sm-6 col-md-6 col-xs-6 MobileHide">
                      <div class="call-plan-form-group call-plan-form-group-name">

                        <input class="form-control" id="customer_name" placeholder="last name"
                          maxlength="30" name="customer-name" required="" type="text">
                        <label for="customer-name"></label>
                        <span class="d-none customer-name-error" style="color: red">
                          Please enter your name
                        </span>
                      </div>
                    </div> -->
                </div>
                <div class="row">
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        id="customer_name"
                        maxlength="30"
                        placeholder="Mobile"
                        name="customer-name"
                        required=""
                        type="text" />
                      <label for="customer-name"></label>
                      <span
                        class="d-none customer-name-error"
                        style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        id="customer_name"
                        placeholder="Email"
                        maxlength="30"
                        name="customer-name"
                        required=""
                        type="text" />
                      <label for="customer-name"></label>
                      <span
                        class="d-none customer-name-error"
                        style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <!-- <select class="form-control">
                      <option>State</option>
                    </select> -->
                      <input
                        class="form-control"
                        id="Statein"
                        placeholder="State"
                        maxlength="30"
                        name="Statein"
                        required=""
                        type="text" />
                      <label for="Statein"></label>
                      <span class="d-none Statein-error" style="color: red">
                        Please enter state
                      </span>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        id="customer_name"
                        maxlength="30"
                        placeholder="City"
                        name="customer-name"
                        required=""
                        type="text" />
                      <label for="customer-name"></label>
                      <span
                        class="d-none customer-name-error"
                        style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12 col-md-12 col-xs-6">
                    <div class="call-plan-form-group call-plan-form-group-name">
                      <input
                        class="form-control"
                        id="customer_name"
                        maxlength="30"
                        placeholder="Message"
                        name="customer-name"
                        required=""
                        type="text" />
                      <label for="customer-name"></label>
                      <span
                        class="d-none customer-name-error"
                        style="color: red">
                        Please enter your name
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 col-sm-12 col-xs-12">
                    <div class="call-plan-form-group">
                      <label class="form-label">Preferred time to talk:</label>
                    </div>
                    <div
                      class="btn-group btn-group-toggle select-call-time select-call-time-js"
                      data-toggle="buttons">
                      <label class="btn btn-outline-sb-green option-1 active">
                        <input
                          data-max="12"
                          data-min="8"
                          id="option1"
                          name="schedule_time"
                          type="radio"
                          value="morning" />

                        10 - 12
                      </label>
                      <label class="btn btn-outline-sb-green option-2">
                        <input
                          data-max="16"
                          data-min="12"
                          id="option2"
                          name="schedule_time"
                          type="radio"
                          value="afternoon" />

                        12 - 2
                      </label>
                      <label class="btn btn-outline-sb-green option-3">
                        <input
                          data-max="20"
                          data-min="16"
                          id="option3"
                          name="schedule_time"
                          type="radio"
                          value="evening" />

                        2 - 4
                      </label>
                      <label class="btn btn-outline-sb-green option-3">
                        <input
                          data-max="20"
                          data-min="16"
                          id="option3"
                          name="schedule_time"
                          type="radio"
                          value="evening" />

                        4 - 6
                      </label>
                      <label class="btn btn-outline-sb-green option-3">
                        <input
                          data-max="20"
                          data-min="16"
                          id="option3"
                          name="schedule_time"
                          type="radio"
                          value="evening" />

                        6 - 8
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 mb-20">
                    <div
                      class="call-plan-form-group text-center mt-30 mobilemt-0 mobilemb-0">
                      <div
                        class="mt-3 sb-primary-cta-button large-btn schedule-a-call trigger-event schedule-a-call-js"
                        data-action="schedule a call-Plan"
                        data-category="offering-Plan"
                        data-label="planning section">
                        Call Me
                      </div>
                      <a
                        href="mf/MobileMutualFund"
                        style="font-size: 10px"
                        target="_self"
                        class="anchorColor desktopHide">
                        Click here to know more about Mutual Funds first
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div
      class="moon-mist-background wealth-section-space talk-to-experts mt-20">
      <div class="container">
        <div class="row d-flex">
          <div class="col-12 col-md-6">
            <div class="talk-to-experts-content">
              <div class="align-self-center">
                <h2 class="wealth-section-title mb-12">
                  <!-- Talk to us Today! -->
                  Don't hesitate. Call us!
                </h2>
                <p class="wealth-section-description">
                  <a
                    class="trigger-event toll-free-number"
                    data-category="conversion"
                    data-action="Click-to-call"
                    data-label="Toll Free Home"
                    href="tel:1800-102-1265">
                    +91{{ contactus }}
                  </a>
                </p>
                <p class="wealth-section-description mb-12 mt-13">
                  Let's Talk!
                  <span class="breakLine"></span>
                  <span class="desktop-break"></span>
                </p>
                <a
                  class="sb-primary-cta-button unset-transform large-btn mt-12 trigger-event"
                  data-action="Create an account"
                  data-category="conversion"
                  data-label="Create an account"
                  data-properties='{"action": "Create an account", "location": "home"}'
                  href="#user/login"
                  (click)="modalPopOpen()">
                  Schedule A Call
                </a>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <div
              class="d-flex flex-row bd-highlight mobile-x-overflow-scroll flex-wrap text-right">
              <img src="../assets/images/img/Talktoexpert.jpg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
<IFA-footer></IFA-footer>
